import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../components/common';
import '../components/common/PageLayout.css';
import './ContactSubmissions.css';

const API_BASE = 'http://localhost:3002';

const ContactSubmissions = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetch(`${API_BASE}/api/contact/json`)
      .then((res) => res.json())
      .then((result) => {
        if (result.success && result.data) setList(result.data);
        else setError('Could not load submissions.');
      })
      .catch(() => setError('Backend not running? Start it: cd server && npm start'))
      .finally(() => setLoading(false));
  }, []);

  const formatDate = (str) => {
    if (!str) return '—';
    const d = new Date(str);
    return isNaN(d.getTime()) ? str : d.toLocaleString();
  };

  const searchLower = search.trim().toLowerCase();
  const filteredList = searchLower
    ? list.filter(
        (row) =>
          (row.name && row.name.toLowerCase().includes(searchLower)) ||
          (row.email && row.email.toLowerCase().includes(searchLower)) ||
          (row.phone && row.phone.toLowerCase().includes(searchLower)) ||
          (row.message && row.message.toLowerCase().includes(searchLower))
      )
    : list;

  return (
    <>
      <div className="hero-gradient-wrap">
        <Header ctaText="Join Community" ctaPath="#courses" />
        <section className="page-hero">
          <h1>Contact form submissions</h1>
          <p>Data saved in your database (server/contact.db). Backend must be running.</p>
          <p className="page-hero-link-wrap">
            <Link to="/contact">Back to Contact</Link>
          </p>
        </section>
      </div>
      <main className="page-layout-main">
        <section className="page-section contact-submissions-section">
          {loading && <p className="contact-submissions-msg">Loading…</p>}
          {error && <p className="contact-submissions-msg contact-submissions-msg--error">{error}</p>}
          {!loading && !error && list.length === 0 && (
            <p className="contact-submissions-msg">No submissions yet. Submit the <Link to="/contact">contact form</Link> to see data here.</p>
          )}
          {!loading && !error && list.length > 0 && (
            <>
              <div className="contact-submissions-search">
                <input
                  type="search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  placeholder="Search by name, email, phone or message..."
                  aria-label="Search submissions"
                  className="contact-submissions-search-input"
                />
                {search && (
                  <button type="button" onClick={() => setSearch('')} className="contact-submissions-search-clear">
                    Clear
                  </button>
                )}
              </div>
              {filteredList.length === 0 ? (
                <p className="contact-submissions-msg">No matching submissions. Try a different search.</p>
              ) : (
              <div className="contact-submissions-table-wrap">
              <table className="contact-submissions-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Message</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredList.map((row) => (
                    <tr key={row.id}>
                      <td>{row.id}</td>
                      <td>{row.name}</td>
                      <td><a href={`mailto:${row.email}`}>{row.email}</a></td>
                      <td>{row.phone || '—'}</td>
                      <td className="contact-submissions-message">{row.message}</td>
                      <td>{formatDate(row.created_at)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
              )}
            </>
          )}
        </section>
      </main>
      <Footer />
    </>
  );
};

export default ContactSubmissions;
